document.addEventListener("DOMContentLoaded", () => {
    const inputsProduct = Array.from(document.querySelectorAll(".swatchInput"));

    const YES_VALUES = [
        "YES",      // Inglês
        "SIM",      // Português
        "OUI",      // Francês
        "SI",       // Espanhol / Italiano sem acento
        "JA",       // Alemão / Holandês
        "نعم"       // Árabe
    ];

    const NO_VALUES = [
        "NO",       // Inglês / Espanhol / Italiano
        "NAO",      // Português sem acento
        "NON",      // Francês
        "NEIN",     // Alemão
        "NEE",      // Holandês
        "لا"        // Árabe
    ];

    function normalizarValor(valor) {
        return String(valor)
            .trim()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .toUpperCase();
    }

    function isYes(input) {
        const valorNormalizado = normalizarValor(input.value);
        return YES_VALUES.includes(valorNormalizado) || input.value.trim() === "نعم";
    }

    function isNo(input) {
        const valorNormalizado = normalizarValor(input.value);
        return NO_VALUES.includes(valorNormalizado) || input.value.trim() === "لا";
    }

    const boxPersonalizacao = document.getElementById("aparecer");
    const nomeCamisa = document.getElementById("nomecamisa");
    const numCamisa = document.getElementById("numcamisa");

    if (!boxPersonalizacao || !nomeCamisa || !numCamisa) {
        return;
    }

    function ativarPersonalizacao() {
        boxPersonalizacao.style.display = "block";

        nomeCamisa.disabled = false;
        numCamisa.disabled = false;

        nomeCamisa.required = true;
        numCamisa.required = true;
    }

    function desativarPersonalizacao() {
        boxPersonalizacao.style.display = "none";

        nomeCamisa.value = "";
        numCamisa.value = "";

        nomeCamisa.required = false;
        numCamisa.required = false;

        nomeCamisa.disabled = true;
        numCamisa.disabled = true;
    }

    function verificarVarianteSelecionada() {
        const algumSimSelecionado = inputsProduct.some(input => {
            return isYes(input) && input.checked;
        });

        if (algumSimSelecionado) {
            ativarPersonalizacao();
        } else {
            desativarPersonalizacao();
        }
    }

    inputsProduct.forEach(input => {
        input.addEventListener("change", verificarVarianteSelecionada);
    });

    const productForms = document.querySelectorAll('form[action*="/cart/add"]');

    productForms.forEach(form => {
        form.addEventListener("submit", () => {
            const algumSimSelecionado = inputsProduct.some(input => {
                return isYes(input) && input.checked;
            });

            if (!algumSimSelecionado) {
                desativarPersonalizacao();
            }
        });
    });

    verificarVarianteSelecionada();
});